import React from 'react'
import { Form } from 'semantic-ui-react'
import { connect } from 'react-redux'
import { loadActiveLocations } from '../../../common/locations/actions'

class LocationFilter extends React.Component {
  componentWillMount() {
    const { loadActiveLocations, activeLocations } = this.props
    if (!activeLocations.size) loadActiveLocations({ sort: 'nameSort' })
  }
  render() {
    // eslint-disable-next-line no-unused-vars
    const { activeLocations, loadActiveLocations, value, onChange, ...remainingProps } = this.props
    const locationOptions = activeLocations.reduce((options, location) => {
      options.push({ value: location._id, text: location.name })
      return options
    }, [])
    if (!remainingProps.multiple) locationOptions.unshift({ value: '', text: 'Vše' })
    let realValue = value
    if (!realValue && remainingProps.multiple) realValue = []
    return (
      <Form.Select
        options={locationOptions}
        value={realValue}
        onChange={(e, value) => onChange(value)}
        {...remainingProps}
      />
    )
  }
}

LocationFilter.defaultProps = {
  multiple: false,
  value: '',
}

LocationFilter.propTypes = {
  loadActiveLocations: React.PropTypes.func.isRequired,
  activeLocations: React.PropTypes.object.isRequired,
  multiple: React.PropTypes.bool,
  value: React.PropTypes.any,
  onChange: React.PropTypes.func.isRequired,
}

export default connect(state => ({
  activeLocations: state.locations.all,
}), { loadActiveLocations })(LocationFilter)



// WEBPACK FOOTER //
// ./src/browser/components/filters/LocationFilter.js